import { ApolloClient } from '@apollo/client'
import gql from 'graphql-tag'
import { WhitelistDeviceInput, WhitelistDeviceStatus } from '../../../../api'

export const MUTATION = gql`
  mutation whitelistDevice($input: WhitelistDeviceInput!) {
    whitelistDevice(input: $input) {
      deviceId
      expiry
    }
  }
`

export async function whitelistDevice(
  client: ApolloClient<unknown>,
  input: WhitelistDeviceInput,
): Promise<WhitelistDeviceStatus> {
  const response = await client.mutate({
    mutation: MUTATION,
    variables: {
      input,
    },
  })

  const result = response.data.whitelistDevice
  if (!result) {
    throw new Error('Token not found')
  }

  return result
}
